import dayjs from 'dayjs';

export const entityNameMap: Record<string, string> = {
  // Customers
  Customer: 'Customer',
  CustomerAddress: 'Customer Address',
  CustomerClass: 'Customer Class',
  CustomerContact: 'Customer Contact',
  CustomerEmail: 'Customer Email',
  CustomerListDetail: 'Customer List Detail',
  CustomerListHeader: 'Customer List Header',
  CustomerPhone: 'Customer Phone',
  CustomerUnit: 'Customer Unit',

  // Parts
  AlternateStockLocation: 'Alternate Stock Location',
  AlternateStockTransactionHeader: 'Alternate Stock Transaction',
  AlternateStockTransactionLine: 'Alternate Stock Transaction Item',
  Part: 'Part',
  PartCache: 'Part Cache',
  PartCountListDetail: 'Part Count List Item',
  PartCountListHeader: 'Part Count List',
  PartListDetail: 'Part List Item',
  PartListHeader: 'Part List',
  PartLocation: 'Part Location',
  PartMaster: 'Part',
  PartReceiptHeader: 'Part Receipt',
  PartReceiptLine: 'Part Receipt Item',
  PartShelvingHeader: 'Part Shelving',
  PartShelvingDetail: 'Part Shelving Item',
  PartSub: 'Part Substitution',
  PartTransaction: 'Part Transaction',
  PartTransactionDetail: 'Part Transaction Item',
  PartTransactionHeader: 'Part Transaction Header',
  SalePart: 'Sale Part',

  // Units
  SaleUnit: 'Sale Unit',
  UnitBase: 'Unit',
  UnitListDetail: 'Unit List Detail',
  UnitListHeader: 'Unit List Header',
  UnitOrderHeader: 'Unit Order',
  UnitOrderLine: 'Unit Order Item',
  UnitReceiptHeader: 'Unit Receipt',
  UnitReceiptLine: 'Unit Receipt Item',
  UnitTransactionHeader: 'Unit Transaction',
  UnitTransactionLine: 'Unit Transaction Line',
  UnitTransChange: 'Unit Transaction',

  // Security
  SystemAppUser: 'App User',
  SystemAppUserRole: 'App User Role',
  SystemRole: 'Role',
  SystemRolePermission: 'Role Permission',
  SystemPermission: 'Permission',
  SystemDocumentLock: 'Document Lock',

  // Reports
  SystemReportColumnDefinition: 'Report Column Definition',
  SystemReportDashboard: 'Report Dashboard',
  SystemReportDashboardWebLink: 'Report Dashboard Web Link',
  SystemReportDefaultDashboard: 'Report Default Dashboard',
  SystemReportDefinition: 'Report Definition',
  SystemReportPermission: 'Report Permission',
  SystemReportRole: 'Report Role',

  // Jobs
  SystemJobScheduler: 'Job Scheduler',
  SystemJobSchedulerHost: 'Job Scheduler Host',
  SystemJobSchedulerQueue: 'Job Scheduler Queue',
  SystemJobSchedulerSettings: 'Job Scheduler Settings',

  // Service
  SystemTechnicianScheduleItem: 'Technician Schedule Item',

  // Location
  SettingsLocation: 'Location',
  SettingsLocationExcludeDepartment: 'Location Exclude Department',
  SettingsLocationOption: 'Location Option',
  SettingsLocationPaymentMethod: 'Location Payment Method',
  SettingsOptionDefault: 'Option Default',
  SettingsOptionGlobal: 'Option Global',

  // Store Schedule
  SettingsLocationBusinessHours: 'Location Business Hours',
  SettingsLocationBusinessHourException: 'Location Business Hour Exception',
  SettingsLocationHoliday: 'Location Holiday',

  // Addresses/Contacts
  SettingsAddressCity: 'City State',
  SettingsAddressCountry: 'Country',
  SettingsEmailType: 'Email Type',
  SettingsCustomerPhoneType: 'Phone Type',
  SettingsStateProvince: 'State',

  // Customer Lookups
  SettingsCustomerClassType: 'Class Type',
  SettingsContactClassType: 'Contact Class Type',
  SettingsAddressZone: 'Zone',

  // General Ledger
  SettingsChartAccountType: 'Account Type',
  SettingsDepartment: 'Department',
  SettingsChartOfAccounts: 'Chart',
  SettingsFiscalYear: 'Fiscal Year',
  SettingsJournalEntryCategory: 'GL Category',
  SettingsBankInformation: 'Bank Accounts',
  SettingsExchangeRate: 'Exchange Rates',
  SettingsMiscellaneousIncomeType: 'Misc Income Types',
  SettingsAccountListDetail: 'Account List Detail',
  SettingsAccountListHeader: 'Account List Header',
  SettingsChartExcludeDepartment: 'Chart Exclude Department',
  SettingsChartExcludeLocation: 'Chart Exclude Location',
  SettingsFiscalPeriod: 'Fiscal Period',
  SettingsFiscalPeriodLocation: 'Fiscal Period Location',
  SettingsJournalEntryHeader: 'Journal Entry Header',
  SettingsJournalEntryLine: 'Journal Entry Line',
  SettingsJournalEntryTemplateHeader: 'Journal Entry Template Header',
  SettingsJournalEntryTemplateLine: 'Journal Entry Template Line',
  SettingsLedgerDefaultField: 'Ledger Default Field',
  SettingsStatementClass: 'Statement Class',

  // Tax
  SettingsSalesTaxExempt: 'Sales Tax Exempt Reason',
  SettingsSalesTaxJurisdiction: 'Sales Tax Jurisdictions',
  SettingsSalesTaxGroup: 'Sales Tax Groups',
  SettingsSalesTaxGroupJurisdiction: 'Sales Tax Group Jurisdiction',
  SettingsSalesTaxLocation: 'Sales Tax Location',
  SettingsSalesTaxRate: 'Sales Tax Rate',

  // Inventory
  SettingsPartProductLine: 'Product Line',
  SettingsMiscellaneousCharge: 'Misc Charges',

  // CRM
  SettingsCommunicationCategory: 'Communication Categories',
  SettingsNoteCategory: 'Note Category',
  SettingsQuoteClosureReason: 'Quote Closure Reasons',
  SettingsReviewInvoiceWorkflow: 'Review Invoice Workflow',
  SettingsEmailTemplate: 'Email Templates',
  SettingsWorkOrderWorkflow: 'Work Order Workflow',
  SettingsAspenCommunityLog: 'Aspen Community Log',
  SettingsCommunication: 'Communication',

  // POS
  SettingsPaymentMethod: 'Payment Methods',
  SettingsPaymentMethodPayableVoucher: 'Payment Method Payable Voucher',
  SettingsPaymentMethodPayableVoucherType:
    'Payment Method Payable Voucher Type',
  SettingsPaymentSettingAgcoPlus: 'Payment Setting AGCO Plus',
  SettingsPaymentSettingCnhCapital: 'Payment Setting CNH Capital',
  SettingsPaymentSettingDeposit: 'Payment Setting Deposit',
  SettingsPaymentSettingGeneralLedger: 'Payment Setting General Ledger',
  SettingsPaymentSettingGravityPayments: 'Payment Setting Gravity Payments',
  SettingsPaymentSettingJohnDeereCredit: 'Payment Setting John Deere Credit',
  SettingsPaymentSettingUnit: 'Payment Setting Unit',
  SettingsPaymentSettingUnprocessedCredit: 'Payment Setting Unprocessed Credit',

  // Rental
  SettingsReservationGroup: 'Reservation Group',
  SettingsRentalGroup: 'Rental Group',
  SettingsRentalCalendar: 'Rental Calendar Settings',
  SettingsRentalRateMatrix: 'Rental Rate Matrix',
  SettingsRentalUtilizationGroup: 'Rental Utilization Group',
  SettingsRentalGroupException: 'Rental Group Exception',
  SettingsRentalGroupMatrix: 'Rental Group Matrix',

  // Warranty
  SettingsSaleWarrSubmissionType: 'Warranty Submission Types',

  // Parts Settings
  SettingsPartGroup: 'Part Group',
  SettingsPartPriceClass: 'Part Price Group',
  SettingsPartSeason: 'Part Season',
  SettingsCustomerSpecialPricing: 'Customer Special Pricing',
  SettingsPartOrderCodeGroup: 'Part Order Code Group',
  SettingsPartManufacturer: 'Part Manufacturer',
  SettingsPartOrderGroup: 'Part Order Group (Parts)',
  SettingsPartBinZone: 'Part Bin Zone',
  SettingsManufacturerOemMap: 'Manufacturer OEM Map',
  SettingsPartCommodity: 'Part Commodity',
  SettingsPartManufacturerReturn: 'Part Manufacturer Return',
  SettingsPartManufacturerPromoDetail: 'Part Manufacturer Promo Detail',
  SettingsPartManufacturerPromoHeader: 'Part Manufacturer Promo Header',
  SettingsPartManufacturerSystem: 'Part Manufacturer System',
  SettingsPartReceivingWrkflow: 'Part Receiving Workflow',
  SettingsPartReceivingWorkflow: 'Part Receiving Workflow',

  // Unit Settings
  SettingsUnitCategory: 'Unit Category',
  SettingsUnitCondition: 'Unit Condition',
  SettingsUnitGroup: 'Unit Group',
  SettingsUnitMake: 'Unit Make',
  SettingsUnitOtherStatus: 'Unit Other Status',
  SettingsUnitSerialType: 'Unit Serial Type',
  SettingsUnitCostGroup: 'Unit Cost Group',
  SettingsUnitDepreciationType: 'Unit Depreciation Type',
  SettingsUnitDepreciationSchedule: 'Unit Depreciation Schedule',

  // Service
  SettingsWorkOrderStatus: 'WO Status Code',
  SettingsInvoiceLaborCategory: 'Invoice Labor Category',
  SettingsWorkOrderPriorityCode: 'WO Priority Codes',
  SettingsInvoiceLaborAdjustmentCode: 'Labor Adjustment Code',
  SettingsServiceCode: 'Service Codes',
  SettingsServiceContractGroup: 'Service Contract Group',
  SettingsServiceContractRateMatrix: 'Service Contract Rate Matrix',
  SettingsServiceContractRateMatrixItem: 'Service Contract Rate Matrix Item',
  SettingsServiceContractGroupRateMatrix: 'Service Contract Group Rate Matrix',

  // Scheduling
  SettingsEmployeeGroup: 'Employee Groups',
  SettingsEmployeeSkill: 'Employee Skills',
  SettingsEmployeeScheduleExceptionType: 'Employee Hours Exception',
  SettingsEmployeeSchedule: 'Employee Schedules',
  SettingsEmployeeGroupUserMap: 'Employee Group User Map',
  SettingsEmployeeScheduleException: 'Employee Schedule Exception',
  SettingsTaskAssignment: 'Task Assignment',
  SettingsTeam: 'Team',
  SettingsTeamUser: 'Team User',

  // Labels
  SettingsLabel: 'Label',

  // Mfg Interfaces Setup
  SettingsInterface: 'Interface',
  SettingsPartManufacturerAgco: 'Part Manufacturer AGCO',
  SettingsPartManufacturerCnh: 'Part Manufacturer CNH',
  SettingsPartManufacturerJohnDeere: 'Part Manufacturer John Deere',
  SettingsPartManufacturerKubota: 'Part Manufacturer Kubota',

  // Vendor
  SettingsVendor: 'Vendor',

  // User Preferences
  SettingsSystemPreferences: 'User Preferences',

  // Legacy mappings for backward compatibility
  UnitCategory: 'Unit Category',
  UnitCondition: 'Unit Condition',
  UnitGroup: 'Unit Group',
  ParentUnit: 'Parent Unit',
  CurrentCustomer: 'Customer Unit',
  RentalGroup: 'Rental Group',
  OrderHeader: 'Part Order',
  OrderLine: 'Part Order Item',
  RentalUtilizationGroup: 'Rental Utilization Group',
  PartPriceClass: 'Part Price Class',
  PartGroup: 'Part Group',
  InvoiceDetail: 'Invoice Detail',
  InvoiceSegment: 'Invoice Segment',
  InvoiceHeader: 'Invoice',
  BillingAddress: 'Billing Address',
  TaxGroup: 'Tax Group',
  EmailType: 'Email Type',
  PhoneType: 'Phone Type',
  ShipMethod: 'Shipping Method',
  TaxExemption: 'Tax Exemption',
  DefSalesPerson: 'Default Salesperson',
  SettingsSearchOption: 'Search Option',
  SettingsAlternateStockLocation: 'Alternate Stock Location',
  TechnicianScheduleItem: 'Tech Schedule',
  WorkInProgress: 'Work In Progress',
  WorkOrderSchedule: 'Work Order Schedule',

  // Priority transactional entities (updated audit triggers)
  WarrantyRequest: 'Warranty Request',
  WarrantyRequestCnh: 'Warranty Request CNH',
  WarrantyRequestSerial: 'Warranty Request Serial',
  WarrantySegment: 'Warranty Segment',
  WarrantySegmentLabor: 'Warranty Segment Labor',
  WarrantySegmentKubota: 'Warranty Segment Kubota',
  WarrantySegmentKubotaCanada: 'Warranty Segment Kubota Canada',
  WarrantySegmentMiscellaneousCharge: 'Warranty Segment Miscellaneous Charge',
  RentalContract: 'Rental Contract',
  SaleDepositDetail: 'Sale Deposit Detail',
  ServiceContractUnit: 'Service Contract Unit',

  // Invoicing & AR (batch triggers)
  InvoiceDetailRemark: 'Invoice Detail Remark',
  InvoiceDetailRental: 'Invoice Detail Rental',
  InvoiceDocumentSerial: 'Invoice Document Serial',
  InvoiceLabor: 'Invoice Labor',
  InvoiceMiscellaneousCharge: 'Invoice Miscellaneous Charge',
  InvoiceOptionAttachment: 'Invoice Option Attachment',
  InvoiceSerial: 'Invoice Serial',
  InvoiceText: 'Invoice Text',
  InvoiceUnitTransactionHeader: 'Invoice Unit Transaction Header',
  JournalEntryFinanceCharge: 'Journal Entry Finance Charge',
  JournalEntryFinanceChargeResultHeader: 'Journal Entry Finance Charge Result Header',
  JournalEntryFinanceChargeResultLine: 'Journal Entry Finance Charge Result Line',
  JournalEntrySerial: 'Journal Entry Serial',

  // Parts (batch triggers)
  PartAnalysis: 'Part Analysis',
  PartAnalysisResult: 'Part Analysis Result',
  PartAssociation: 'Part Association',
  PartAttachment: 'Part Attachment',
  PartAvailabilityHistory: 'Part Availability History',
  PartCatalogPackingListDetail: 'Part Catalog Packing List Detail',
  PartCatalogPackingListHeader: 'Part Catalog Packing List Header',
  PartGenericOrderSubmission: 'Part Generic Order Submission',
  PartOrderCodeAlert: 'Part Order Code Alert',
  PartOrderCodeMatrix: 'Part Order Code Matrix',
  PartOrderSerial: 'Part Order Serial',
  PartPriceFile: 'Part Price File',
  PartPriceFileLocation: 'Part Price File Location',
  PartPriceFileLog: 'Part Price File Log',
  PartPriceFileStaging: 'Part Price File Staging',
  PartPriceMatrix: 'Part Price Matrix',
  PartReceiptSerial: 'Part Receipt Serial',
  PartSubStaging: 'Part Sub Staging',
  PartSuggestedOrder: 'Part Suggested Order',
  PartSuggestedOrderResult: 'Part Suggested Order Result',
  PartValue: 'Part Value',

  // Payments & vouchers (batch triggers)
  Payment: 'Payment',
  PaymentDetailAgcoPlus: 'Payment Detail AGCO Plus',
  PaymentDetailApVoucher: 'Payment Detail AP Voucher',
  PaymentDetailCnhCapital: 'Payment Detail CNH Capital',
  PaymentDetailGravityPayments: 'Payment Detail Gravity Payments',
  PaymentDetailJohnDeereCredit: 'Payment Detail John Deere Credit',
  PaymentDetailReceivedOnAccount: 'Payment Detail Received On Account',
  PaymentDetailUnprocessedCredit: 'Payment Detail Unprocessed Credit',
  PaymentReceivablesDetail: 'Payment Receivables Detail',
  PaymentSettingPerseusPay: 'Payment Setting Perseus Pay',
  PaymentSettingsReceivable: 'Payment Settings Receivable',
  PerseusPaymentDetails: 'Perseus Payment Details',
  Voucher: 'Voucher',
  VoucherAttachment: 'Voucher Attachment',
  VoucherLine: 'Voucher Line',
  VoucherPayment: 'Voucher Payment',
  VoucherSerial: 'Voucher Serial',

  // Quotes (batch triggers)
  QuoteDetails: 'Quote Details',
  QuoteSerial: 'Quote Serial',
  QuoteUnit: 'Quote Unit',
  QuoteUnitCost: 'Quote Unit Cost',
  QuoteUnitOption: 'Quote Unit Option',

  // Rental (batch triggers)
  RentalContractSerial: 'Rental Contract Serial',
  RentalGroupMatrixCustomer: 'Rental Group Matrix Customer',
  RentalGroupMiscellaneousCharge: 'Rental Group Miscellaneous Charge',
  RentalGroupPart: 'Rental Group Part',
  RentalLostSale: 'Rental Lost Sale',
  RentalRateMatrixItem: 'Rental Rate Matrix Item',
  RentalUnit: 'Rental Unit',

  // RentHub integrations
  RentHubAspenMiscChargeMap: 'RentHub Aspen Misc Charge Map',
  RentHubAspenPaymentMethodMap: 'RentHub Aspen Payment Method Map',
  RentHubDefaultTaxGroup: 'RentHub Default Tax Group',
  RentHubMiscCharge: 'RentHub Misc Charge',
  RentHubUnitStatus: 'RentHub Unit Status',

  // Sales units
  SaleUnitTradeIn: 'Sale Unit Trade In',

  // Service contracts & scheduling
  ServiceContract: 'Service Contract',
  ServiceContractGroupInvoiceDetail: 'Service Contract Group Invoice Detail',
  ServiceContractSerial: 'Service Contract Serial',
  ServiceTechSchedule: 'Service Tech Schedule',
  ServiceTechScheduleCategory: 'Service Tech Schedule Category',
  ServiceTechSchedulePriority: 'Service Tech Schedule Priority',
  ServiceTechScheduleSegment: 'Service Tech Schedule Segment',

  // Units (batch triggers)
  UnitAttachment: 'Unit Attachment',
  UnitComment: 'Unit Comment',
  UnitMeter: 'Unit Meter',
  UnitOption: 'Unit Option',
  UnitOrderLineOption: 'Unit Order Line Option',
  UnitOrderSerial: 'Unit Order Serial',
  UnitReceiptSerial: 'Unit Receipt Serial',
  UnitSerial: 'Unit Serial',
  UnitStockNumber: 'Unit Stock Number',
  UnitTemplateAttachment: 'Unit Template Attachment',
  UnitTemplateBase: 'Unit Template Base',
  UnitTemplateOption: 'Unit Template Option',
  UnitTransferDetail: 'Unit Transfer Detail',
  UnitTransferHeader: 'Unit Transfer Header',
  UnitTransferStatus: 'Unit Transfer Status',

  // Vendor (batch triggers)
  VendorAttachment: 'Vendor Attachment',
  VendorCustomField: 'Vendor Custom Field',
  VendorTemplateHeader: 'Vendor Template Header',
  VendorTemplateLine: 'Vendor Template Line',

  // Warranty segments (batch triggers)
  WarrantySegmentCnh: 'Warranty Segment CNH',
  WarrantySegmentJohnDeere: 'Warranty Segment John Deere',

  SegmentComment: 'Segment Comment',
  PartOrderLine: 'Part Order Line',
  PartOrderHeader: 'Part Order Header',
  InvoiceSegmentTask: 'Invoice Segment Task',
  ServiceSchedule: 'Service Schedule',

  // Work order (batch triggers)
  WorkOrderQueuePosition: 'Work Order Queue Position',
  WorkOrderStatusOrder: 'Work Order Status Order',
  WorkOrderTechnicianOrder: 'Work Order Technician Order',

  // Attachments / misc
  AttachmentImage: 'Attachment Image',
};

export const formatEntityName = (value?: string): string => {
  if (!value) return '';
  return entityNameMap[value] ?? value;
};

export const formatTimestamp = (value?: string): string => {
  if (!value) return '';
  const step1 = value.replace(' ', 'T');
  const step2 = step1.replace(/ ([-+]\d{2}:\d{2})$/, '$1');
  const step3 = step2.replace(/\.(\d{3})\d+/, '.$1');
  const d = dayjs(step3);
  if (!d.isValid()) return '';
  return d.format('MM/DD/YYYY HH:mm:ss');
};

export const tryParseJson = (value: unknown): any => {
  if (value == null) return null;
  if (typeof value === 'object') return value as any;
  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  }
  return null;
};

export const humanizeLabel = (input: string): string => {
  if (!input) return '';
  const withSpaces = input
    .replace(/_/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .trim();
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
};

export const parseChangeItems = (
  raw: unknown
): Array<{ field: string; oldValue: any; newValue: any }> => {
  let obj = tryParseJson(raw) ?? raw;
  const result: Array<{ field: string; oldValue: any; newValue: any }> = [];
  if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
    const entries = Object.entries(obj as Record<string, any>);
    // Unwrap single top-level container (e.g., CustomerListHeader_Audit)
    if (entries.length === 1 && typeof entries[0][1] === 'object') {
      obj = entries[0][1];
    }

    Object.entries(obj as Record<string, any>).forEach(([field, val]) => {
      if (val && typeof val === 'object') {
        const keys = Object.keys(val).reduce<Record<string, any>>((acc, k) => {
          acc[k.toLowerCase()] = (val as any)[k];
          return acc;
        }, {});
        const oldValue =
          keys['old'] ?? keys['oldvalue'] ?? keys['previous'] ?? keys['prev'];
        const newValue =
          keys['new'] ?? keys['newvalue'] ?? keys['value'] ?? keys['next'];
        if (oldValue !== undefined || newValue !== undefined) {
          result.push({ field: humanizeLabel(field), oldValue, newValue });
          return;
        }
        // One more nested level guard: look for first nested object with old/new
        const nested = Object.entries(val as Record<string, any>).find(
          ([, v]) =>
            v &&
            typeof v === 'object' &&
            ('old' in v || 'new' in v || 'newValue' in v)
        );
        if (nested) {
          const nk = Object.keys(nested[1]).reduce<Record<string, any>>(
            (acc, k) => {
              acc[k.toLowerCase()] = (nested[1] as any)[k];
              return acc;
            },
            {}
          );
          result.push({
            field: humanizeLabel(field),
            oldValue:
              nk['old'] ?? nk['oldvalue'] ?? nk['previous'] ?? nk['prev'],
            newValue: nk['new'] ?? nk['newvalue'] ?? nk['value'] ?? nk['next'],
          });
          return;
        }
      }
      result.push({ field: humanizeLabel(field), oldValue: '', newValue: val });
    });
  }
  return result;
};

export const getActionVerb = (
  action?: string
): 'added' | 'updated' | 'deleted' | '' => {
  if (!action) return '';
  const a = action.toLowerCase();
  if (a === 'insert' || a === 'add' || a === 'created' || a === 'create')
    return 'added';
  if (a === 'delete' || a === 'removed' || a === 'remove') return 'deleted';
  if (
    a === 'update' ||
    a === 'modified' ||
    a === 'modify' ||
    a === 'change' ||
    a === 'changed'
  )
    return 'updated';
  return '';
};

export const capitalize = (s: string): string =>
  s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
